import React from 'react'
import {GridColDef} from '@mui/x-data-grid'
import {Button} from '@mui/material'

export const createUserColumns = (
  onClickAutoResetPassword: (userId: string) => void,
  onClickDelete: (userId: string) => void,
  canDelete?: boolean,
) => {
  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'Id',
      flex: 1,
    },
    {
      field: 'email',
      headerName: 'Email address',
      flex: 1,
    },
    {
      field: 'Admin',
      headerName: 'Admin',
      valueGetter: params => (params.row.admin ? 'Yes' : 'No'),
      flex: 1,
    },
    {
      field: 'actions',
      headerName: '',
      hideable: false,
      disableColumnMenu: true,
      type: 'actions',
      width: 340,
      renderCell: params => (
        <>
          <Button
            variant="contained"
            onClick={() => {
              const confirmed = window.confirm(
                "Are you sure you want to automatically reset this user's password?",
              )
              if (confirmed) {
                onClickAutoResetPassword(params.id.toString())
              }
            }}>
            Auto Reset password
          </Button>
          {canDelete && (
            <Button
              variant="contained"
              color="error"
              sx={{ml: 1}}
              onClick={() => {
                const confirmed = window.confirm(
                  'Are you sure you want to delete this user? This action cannot be undone.',
                )
                if (confirmed) {
                  onClickDelete(params.id.toString())
                }
              }}>
              Delete
            </Button>
          )}
        </>
      ),
    },
  ]
  return columns
}
